import { API, graphqlOperation } from 'aws-amplify';

const getPreview = (template) => {
    let t = null;
    if(typeof(template) === 'string') {
      t = JSON.parse(template);
    } else {
      t = template;
    }
    if(!t) {
      return null;
    }
    let p = t.HtmlPart;
    console.debug('Getting variant preview...')
    p = p.replace(/{{ ?PRODUCT_IMAGE_?C?[a-z0-9-]{0,40}_\d+ ?}}/gi, 'https://placehold.co/200x200/png?text=PRODUCT+IMAGE');
  p = p.replace(/<img src="[\w\d:/.-]+\/pixel\/message\/{{ MESSAGE_ID }}\/pixel.png" alt="">/gi, '<img src="https://placehold.co/1x1/png">');
    return p;
  }

const sortDesigns = (a,b) => {
  return a.campaign.name.localeCompare(b.campaign.name) || a.name.localeCompare(b.name);
   
}

export default {
    namespaced: true,
    state: {
        entity: 'CampaignVariant',
        list: null,
        item: null,
        nextToken: null,
        existingDesigns: null,
        preview: null
    },
    mutations: {
        list: (state, payload) => { state.list = payload.append ? (state.list || []).concat(payload.value) : payload.value },
        item: (state, payload) => { state.item = payload.value },
        preview: (state, payload) => { state.preview = payload.value },
        nextToken: (state, payload) => { state.nextToken = payload.value },
        existingDesigns: (state, payload) => {state.existingDesigns = (payload.append ? (state.existingDesigns || []).concat(payload.value) : payload.value).sort(sortDesigns)},
    },
    getters: {
    },
    actions: {
        async get(context, payload) {
            const q = await API.graphql(graphqlOperation( /* GraphQL */`
            query GetCampaignVariant($id: ID!) {
              getCampaignVariant(id: $id) {
                id
                campaignID
                name
                active
                subject
                templateSES
                templatePreview
                templateUnlayer
                templateSpecs { ...specs }
                templateSpecsNew { ...specs }
                templateSpecsCategories {
                  productCategoryID
                  specs { ...specs }
                }
              }
            }

            fragment specs on TemplateRecommendationsSpecs {
                  recommendationsCount
                  name
                  price
                  image
                  sale
                  description
                  originalPrice
                  stripDescription
                  defaultSale
                  saleTemplate
                  originalPriceTemplate
            }

            `, { id: payload.id }));
            let v = q.data.getCampaignVariant;
            
            v.templateUnlayer = JSON.parse(v.templateUnlayer);
            v.templateSES = JSON.parse(v.templateSES);
            v.preview = getPreview(v.templateSES || v.templatePreview)
            if(!payload.noStore) {
              context.commit('item', {value: v });
              // this is probably never used
              context.commit('preview', {value: v.preview });
            }
            return v;
        },
        

        // not used yet
        async list(context, payload) {
            const v = await API.graphql(graphqlOperation(/* GraphQL */`
            query CampaignsVariants(
              $campaignID: ID
              $nextToken: String
            ) {
            campaignVariantsByCampaignName(
                campaignID: $campaignID
                sortDirection: ASC
                limit: 1000
                nextToken: $nextToken
              ) {
                items {
                  id
                  name
                  active
                  subject
                  templateSES
                  templatePreview # just load it, optimize later...
                }
                nextToken
              }
            }
            `, payload ));
            let variants = v.data.campaignVariantsByCampaignName.items;
            variants.forEach(v => v.preview = getPreview(v.templateSES || v.templatePreview))
            context.commit('list', {value: variants, append: !!payload?.nextToken });
            context.commit('nextToken', {value: v.data.campaignVariantsByCampaignName.nextToken });
            if(context.state.nextToken) {
              await context.dispatch('list', { ...payload, nextToken: context.state.nextToken });
            }
          },

          async create(context, payload) {
            console.debug('variants/create payload', payload);
            // get domain object from payload
            
            // copy global settings from campaign
            let specs = {...payload.campaign.templateSpecs}; 
            
            let name = String.fromCharCode(payload.campaign.variants[payload.campaign.variants.length - 1].name.charCodeAt(0) + 1);
            let input = Object.assign({
              active: false,
              name,
              campaignID: payload.campaign.id,
              //owner: payload.domain.owner, 
              editors: [payload.domain.owner, ...(payload.domain.editors || [])],
              templateSpecs: specs,
              templateSpecsNew: {...specs},
              templateSpecsCategories: [],
            }, payload.fields);
            var r = await API.graphql(graphqlOperation(`
              mutation CreateCampaignVariant(
                $input: CreateCampaignVariantInput!
                $condition: ModelCampaignVariantConditionInput
              ) {
                createCampaignVariant(input: $input, condition: $condition) {
                  id
                }
              }
            `, { input }));
            await context.dispatch('list', { campaignID: payload.campaign.id });
            return r.data.createCampaignVariant;
          },

          async updateFields(context, payload) {
            let f = payload.fields;
            
            if(f.templateUnlayer) {
              f.templateUnlayer = JSON.stringify(f.templateUnlayer);
            }
            
            if(f.templateSES) {
              f.templateSES = JSON.stringify(f.templateSES);
            }

            await API.graphql(graphqlOperation(`
              mutation UpdateCampaignVariant(
                $input: UpdateCampaignVariantInput!
                $condition: ModelCampaignVariantConditionInput
              ) {
                updateCampaignVariant(input: $input, condition: $condition) {
                  id
                  campaignID
                }
              }
            `, { input: Object.assign({ id: context.state.item.id }, f )}));
            
            return context.dispatch('get', { id: context.state.item.id });
            //return r.data.updateDomain;
          },

          async updateVariant(context, payload) {
            
            if(payload.templateUnlayer) {
              payload.templateUnlayer = JSON.stringify(payload.templateUnlayer);
            }
            
            if(payload.templateSES) {
              payload.templateSES = JSON.stringify(payload.templateSES);
            }

            let r = await API.graphql(graphqlOperation(`
              mutation UpdateCampaignVariant(
                $input: UpdateCampaignVariantInput!
                $condition: ModelCampaignVariantConditionInput
              ) {
                updateCampaignVariant(input: $input, condition: $condition) {
                  id
                  campaignID
                }
              }
            `, { input: payload}));
            
            //return context.dispatch('get', { id: context.state.item.id });
            return r.data.updateCampaignVariant;
          },

          async existingDesigns(context, payload) {
            // TODO filter is not working - maybe it is needed to creatwe the attributes with the null walue for this to work
            // filtered agian below
            const c = await API.graphql(graphqlOperation(/* GraphQL */ `
            query ExistingDesignsV($nextToken: String) {
              listCampaignVariants(filter: {not: {and: {templatePreview: {attributeType: _null}, templateSES: {attributeType: _null}}}}, nextToken: $nextToken) {
                 items {
                  id
                  name
                  campaign {
                    name
                    state
                    scheduleType
                    domain {
                      name
                      createdAt
                    }
                  }
                  templateSES
                  templatePreview
                }
                nextToken
              }
            }
            
            `, payload ));
            let campaigns = c.data.listCampaignVariants.items;
            campaigns.filter(c => !!c).forEach(c => { c.preview = getPreview(c.templateSES || c.templatePreview); delete(c.templateSES); delete(c.templatePreview) });
            context.commit('existingDesigns', {value: campaigns.filter(c => c.preview), append: !!payload.nextToken });
            if(c.data.listCampaignVariants.nextToken) {
              await context.dispatch('existingDesigns', { nextToken: c.data.listCampaignVariants.nextToken });
            }
          },
    }
}